import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const TimeSchedule = () => {
  return (
    <Container>


    <h2 className="display-6 fw-bold my-4">
    Time-schedule

    </h2>
    <hr />
   
      <p className="joab-common-para my-2 ">
      All manuscripts we receive are handled electronically throughout the consideration process. Authors are usually informed within 48 hours if the paper is not being considered for peer-review (desk-rejection). Most referees deliver a peer-review report within fourteen days or other agreed time limit, and submit their peer-review reports online. Decisions by editors are made very rapidly after receipt of all peer-review reports.
      </p>
    
     
   
    

  </Container>
  );
};

export default TimeSchedule;
